import anthropicIconUrl from '@lobehub/icons-static-svg/icons/anthropic.svg'
import claudeIconUrl from '@lobehub/icons-static-svg/icons/claude-color.svg'
import deepSeekIconUrl from '@lobehub/icons-static-svg/icons/deepseek-color.svg'
import geminiIconUrl from '@lobehub/icons-static-svg/icons/gemini-color.svg'
import gemmaIconUrl from '@lobehub/icons-static-svg/icons/gemma-color.svg'
import googleIconUrl from '@lobehub/icons-static-svg/icons/google-color.svg'
import metaIconUrl from '@lobehub/icons-static-svg/icons/meta-color.svg'
import mistralIconUrl from '@lobehub/icons-static-svg/icons/mistral-color.svg'
import openAiIconUrl from '@lobehub/icons-static-svg/icons/openai.svg'
import qwenIconUrl from '@lobehub/icons-static-svg/icons/qwen-color.svg'
import snowflakeIconUrl from '@lobehub/icons-static-svg/icons/snowflake-color.svg'

type ProviderIconProps = {
  provider: string
  modelName?: string
  className?: string
}

function iconUrlFor(
  provider: string,
  modelName = '',
): string | null {
  const identity = `${provider} ${modelName}`.toLocaleLowerCase()

  if (identity.includes('claude')) return claudeIconUrl
  if (identity.includes('gemini')) return geminiIconUrl
  if (identity.includes('gemma')) return gemmaIconUrl
  if (identity.includes('gpt') || provider === 'OpenAI') {
    return openAiIconUrl
  }
  if (identity.includes('qwen')) return qwenIconUrl
  if (identity.includes('mistral')) return mistralIconUrl
  if (identity.includes('deepseek')) return deepSeekIconUrl
  if (identity.includes('llama') || provider === 'Meta') {
    return metaIconUrl
  }
  if (identity.includes('snowflake')) return snowflakeIconUrl
  if (provider === 'Anthropic') return anthropicIconUrl
  if (provider === 'Google') return googleIconUrl

  return null
}

export function hasProviderIcon(
  provider: string,
  modelName?: string,
): boolean {
  return iconUrlFor(provider, modelName) !== null
}

export function ProviderIcon({
  provider,
  modelName,
  className = '',
}: ProviderIconProps) {
  const iconUrl = iconUrlFor(provider, modelName)

  if (!iconUrl) return null

  return (
    <img
      className={`provider-icon ${className}`.trim()}
      src={iconUrl}
      width="16"
      height="16"
      alt=""
      aria-hidden="true"
      data-provider-icon={provider}
      draggable="false"
    />
  )
}
